/**
 * Mosaic Gallery – infinite scroll with reduced-motion support
 */
(function () {
  const galleries = document.querySelectorAll('[data-mosaic-gallery]');
  if (!galleries.length) return;

  function init() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    galleries.forEach(function (track) {
      if (prefersReducedMotion) {
        track.style.animationPlayState = 'paused';
      } else {
        track.style.animationPlayState = '';
      }
    });
  }

  init();
  window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', init);
})();
